export type RefundSource = "orders" | "transactions";

export function issueRefundPath(transactionId: string, source: RefundSource) {
  return `/transactions/${transactionId}/refund`;
}

export function refundActiveNav(source: RefundSource) {
  return source === "orders" ? "/orders" : "/transactions";
}
